import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = '游戏资讯 - 18网页游戏';
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [pathname]);

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.18webgame.com' },
      { '@type': 'ListItem', position: 2, name: '游戏资讯', item: 'https://www.18webgame.com/article' },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      <main className="pt-16">
        <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-900 font-medium whitespace-nowrap">游戏资讯</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">游戏资讯</h1>
            <p className="text-sm md:text-base text-foreground-600 mb-10">了解最新网页游戏动态、深度评测和实用攻略</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative w-full aspect-[16/10] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                      {article.category}
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h2 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug mb-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <div className="flex items-center gap-3">
                        <span>{article.date}</span>
                        <span>{article.author}</span>
                      </div>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i> 5 分钟阅读
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-3 flex-wrap">
                      {article.tags.map((tag) => (
                        <span key={tag} className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}